const exzends = (...rest) => Object.assign({}, ...rest)
export default exzends



// WEBPACK FOOTER //
// ./src/common/exzends.js